import { result } from 'underscore';
import { odata } from '@bingads-webui/http-util';
import config from '@bingads-webui-component-legacy/config/index';

export const getImageData = async (id) => {
  const cid = result(config.get('CurrentCustomer'), 'Id');
  const aid = result(config.get('CurrentAccount'), 'Id');
  const url = `${config.get('odata.url')}${config.get('odata.path')}/Customers(${cid})/Accounts(${aid})/Images(${id})`;

  return odata.get(url, { oDataToken: config.get('odata.token') });
};
